import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton } from "react-bootstrap";
import { useState, useEffect} from "react";
import ListUserTable from "Containers/Private/User/List/ListUserTable";
import {useLocation } from 'react-router-dom';
import { STATUSES } from "Utils/constants";
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {GetUserTextInputData, GetUserCheckboxInputData, GetUserDateInputData, GetUserPhoneInputData, GetUserSelectInputData, GetUserRadioInputData } from 'Containers/Private/Organization/Data files/UserFields';
import {GetTextInputData, GetCheckboxInputData, GetDateInputData, GetPhoneInputData, GetSelectInputData, GetRadioInputData, GetSelectInputObj } from 'Containers/Private/Organization/Data files/OrganizationFields';
import {ACTIONS,formInfoReducer} from 'Containers/Private/Organization/OrganizationFormDataReducer'
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import {Link, useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { getOrganizationList } from "Utils/utilityFunctions";
import {OrgList} from "Components/OrgList/OrgList";
import ListDocumentsTable from "./ListDocumentsTable";

const ListDocuments = () => {
    
   /* useEffect(() => {
        localStorage.removeItem('backRedirect');
    },[]);*/
    

    const [showPopup, setShowPopup] = useState(false);
    const navigate = useNavigate();

    

  let location = useLocation();
  var passedData = location.state;
  //console.log("PASSED DATA");
  //console.log(passedData);

    const [isPSOAdmin, setIsPSOAdmin] = useState(false);
    const [isPSOPPCAdmin, setIsPSOPPCAdmin] = useState(false);
    const [allowEdit, setAllowEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isListLoading, setIsListLoading] = useState(false);
    const [filterData, setFilterData] = useState(null);
  
    var dispatch = useDispatch();


  const loginState = store.getState().loginInfo;
  var [orgListData, setOrgListData] = useState([]);
 


  const getFilterData = async () => {   

    var url = '/api/dlms/getFilter';
    const loginState = store.getState().loginInfo;
    
    return http.post(url, null,{
        headers: {
            "Authorization": "Bearer " + loginState.token
            //"Referrer-Policy": "strict-origin-when-cross-origin"
        }
    });
}

const loadFilterData = () => {
        setIsLoading(true);
        getFilterData().then((res) => {
            //console.log("getFilterData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;
                setFilterData(d);
                    //console.log(d);
                    //setIsPSOAdmin(d.psoadmin);
                    //setIsPSOPPCAdmin(d.psoppcadmin);
                    //setAllowEdit(d.allowEdit);


               
            }

          
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);
           
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        setIsLoading(false);
    };

  const setInitialSelectData = (dispatch, options) => {
        //console.log("setinitialselectdata", options);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            options: options
        })
    }

  //console.log(loginState);
  

  //const [status, setStatus] =  useState(passedStatusValue());
  //const passedOrg =  passedOrgValue(); 
  //const [currentOrgId,setCurrentOrgId] = useState(-1);

  

  var [orgList,orgListInputDispatch] = GetSelectInputObj({
    id:"select",
    name:"org",
    value:-1,
    options:[],
    label:"Select an Organization",
    description:"",
    title:"",
    placeholder:"",
    required:true, 
    isInvalid:false,
    errors:[],
    isValid:false,
    successMsgs: [],
    disabled:"",
    readOnly:"",
    hideFieldOrgTypes:""
});

  /*var [orgList,orgListInputDispatch] = GetSelectInputObj({
    id:"select",
    name:"org",
    value:-1,
    options:[],
    label:"Select an Organization",
    description:"",
    title:"",
    placeholder:"",
    required:true, 
    isInvalid:false,
    errors:[],
    isValid:false,
    successMsgs: [],
    disabled:"",
    readOnly:"",
    hideFieldOrgTypes:""
});*/



  /*var orgListValues = (orgList, selectedValue) => {
    //console.log(orgList);
    //console.log(selectedValue);
    var objArr = [];
    objArr.push({
        index: 0, 
        value: -1, 
        title: null,
        displayValue: "Select Organization", 
        isSelected: selectedValue==null ? true : false
    });

    for (var i = 0; i < orgList.length; i++) {
        var x = orgList[i];
        //console.log(x);

        var idText = "";
        if(x.psoId!=null){
            idText = "(" + x.psoId + ")";
        }
        objArr.push({
            index: x.id, 
            value: x.id, 
            title: "Select organization " + x.name,
            displayValue: x.name + " " + idText, 
            isSelected: selectedValue==x.id ? true : false
        });
    }

    return objArr;
};*/

  
  //console.log(loginState.token);


//const handleOrgChange = () => {

//}

    const handleClose = () => { 
        setShowPopup(false);
        orgListInputDispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: -1
        })
    };

  /*const loadOrgs = async () => {
    setIsLoading(true);
    const res = await http.post('api/manage/user/getorganizations', {
            headers: {
                "Authorization": "Bearer " + loginState.token
                //"Referrer-Policy": "strict-origin-when-cross-origin"
            }
      }).then(res=>{
        
          //console.log("statuses");
          //console.log(res);

          if (res.status==1) {
                //console.log("loadOrganizations ", res.data);
                var d = res.data;

                setOrgListData(d);
                setInitialSelectData(orgListInputDispatch,orgListValues(d, -1));


                //console.log(orgList);
                //setIsPSOPPCAdmin(d.isPSOPPCAdmin);
                //setIsPSOAdmin(d.isPSOAdmin);
                //setAllowEdit(d.allow_edit);
          }
          else{
            
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data:{}
                }
            });
          }
          
      }).catch(function (error) {


           
            



            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data:{}
                }
            });
            //console.log(error);
            //console.log("error caught from loadCompletedPSETestBatches()");
      });  
    };*/

    useEffect(() => {
        loadFilterData();
    }, []);

    const handleCreateUser = (e) => {
        //console.log(orgList);
        //console.log(orgListData);
        //console.log(orgList.value);
        
        if(orgList.value!=-1){
            //console.log("HANDLE CREATE USER", e);
            var result = orgListData.find(obj => {
                return obj.id == orgList.value;
            });
            //console.log(result);
            
            //localStorage.setItem('state', JSON.stringify(state));
            //localStorage.setItem('backRedirect', JSON.stringify(backRedirect));
            
            navigate(
                "/manage/createUser",
                { state: {
                    psoId: result.psoId,
                    orgName: result.name,
                    orgId: result.id,
                    orgTypeId: result.organizationTypeId,
                    orgType: result.organizationType,
                    backRedirect: {
                        path: location.pathname,
                        state: location.state
                    }
                }}
                /*
                    const psoId =  passedData.psoId;
                    const orgName =  passedData.orgName;
                    const organizationId =  passedData.orgId;
                    const orgTypeId =  24;
                */
            );
            
        }
        else{
           
            orgListInputDispatch({
                type: ACTIONS.SELECT_SET_ERRORS,
                errors: ["Please select a valid organization."]
            })
        }
    }

  return (
    isLoading==false ?
    <Row>
      
        <Row >
                <Col xl={11} lg={11} md={12} sm={12}>
                    
                    <Card className="p-4" >
                        <Card.Body className="text-start">
                            <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Manage Documents</h1>
                            
                            <Row>
                                <Form>
                                    <Row>
                                        <Col>
                                            {filterData!=null ?<ListDocumentsTable setShowPopup={setShowPopup} orgType="PSO" info={{filterData: filterData , isLoading: isLoading}}/> : null}
                                        </Col> 
                                    </Row>                  
                                </Form>
                            </Row>
                                
                        </Card.Body>
                    </Card>
{
                    isPSOPPCAdmin!=null && isPSOPPCAdmin==true
                                            ?
                        <Modal className="modal action" size="lg" backdrop="static" keyboard={false} show={showPopup} onHide={handleClose}>
                            <Modal.Header>
                                <Modal.Title className="blue sem-bold">Select a PSO Organization</Modal.Title>
                                <CloseButton className="align-self-start" onClick={handleClose}></CloseButton>
                            </Modal.Header>
                            <Modal.Body>
                            
                                <Stack direction="horizontal" className="popup-message action-message-body">
                                    <div className="message w-100">
                                        {
                                            
                                            
                                            //OrgList({setOrgListData:setOrgListData, orgListData:orgListData, orgList:orgList, orgListInputDispatch:orgListInputDispatch, isListLoading:isListLoading, setIsListLoading:setIsListLoading}).element()
                                            
                                        }

                                        {<OrgList setOrgListData={setOrgListData} orgListData={orgListData} orgList={orgList} orgListInputDispatch={orgListInputDispatch} isListLoading={isListLoading} setIsListLoading={setIsListLoading}></OrgList>}
                                        {/*OrgList({setOrgListData:setOrgListData, orgListData:orgListData}).element()*/}
                                        {/*<Form>
                                            
                                            <FormInputDisplay fieldData={orgList} inputDispatch={orgListInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={{is: false, labelCols: {lg:12}, inputCols: {lg:12}}}></FormInputDisplay>
                                            
                                        </Form>*/}
                                    </div>
                                </Stack>

                            </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={handleCreateUser} variant="popup-confirm">
                                    Continue
                                </Button>
                            </Modal.Footer>
                        </Modal>
                     
                        :   null
                            
                        
                                        }
                    

                </Col>
            </Row>
          
    </Row>
                        :null    
  )
}

export default ListDocuments;